var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class ProjectListReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.isGenerating = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        titleService.setTitle(titleService.getTitle() + ' : Project List Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.projectIds = JSON.parse(window.localStorage.getItem(x.get('id'))).projectIds;
                this.loadReport();
            });
        });
    }
    loadReport() {
        return this.reportsApi.getProjectListReportData(this.projectIds).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
}
